// there is a bug in gorhom bottom sheet that emits warnings
// in the test env. this function allows us to disable scrollability
// in testing only while getting the correct behavior in the app.
// this should be factored out once bottom sheet is patched and
// we're able to upgrade to the patched version.
//
// https://github.com/gorhom/react-native-bottom-sheet/issues/1919

// TODO: https://varomoney.atlassian.net/browse/JT-143161
// `allowScrolling` is broken per the attached ticket. for now
// we'll disable this but this should be set to `true` once that is fixed.
export const bottomSheetScrollConfig = () => false;
